import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingBeefFeedProduction, setFootprintingBeefFeedProductionAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_FEED_PRODUCTION } from "consts";

import { BeefFeedProduction } from "models";

export const useMutateFootprintingBeefFeedProduction = (
  feedInformationId: string,
  primaryDataId: string,
  farmId: string,
  year: number,
  onSuccess?: () => void
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_BEEF_FEED_PRODUCTION, feedInformationId, isAdmin],
      mutationFn: (data: BeefFeedProduction) =>
        isAdmin ? setFootprintingBeefFeedProductionAdmin(feedInformationId, data) : setFootprintingBeefFeedProduction(feedInformationId, data),
      onSuccess: async () => {
        await invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_BEEF_FEED_PRODUCTION, feedInformationId, isAdmin],
          ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
        onSuccess?.();
      },
    },
    queryClient
  );
};
